import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=527aa0b7&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=527aa0b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527aa0b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('527aa0b7')) {
      api.createRecord('527aa0b7', component.options)
    } else {
      api.reload('527aa0b7', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=527aa0b7&scoped=true&", function () {
      api.rerender('527aa0b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2TYfLINJxB0Pg/JS/teamMember.vue"
export default component.exports